module.exports = __webpack_public_path__ + "img/lx_gzdp.12fb1e90.svg";